import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import OperacoesHeader from './OperacoesHeader';
import OperacoesFilter from './OperacoesFilter';
import OperacoesTable from './OperacoesTable';
import { useOperacoesListagem, useOperacoesNavegacao } from '../hooks';

const OperacoesCard = ({
  clienteId = null,
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  // Hooks
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginationState,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    handlePaginationChange,
    setPaginationState
  } = useOperacoesListagem(clienteId);
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = useOperacoesNavegacao();
  return <Card>
      <CardBody>
        {showHeader && <OperacoesHeader totalRegistros={totalRegistros} onAdicionar={showActions ? handleAdicionar : undefined} />}

        {showFilter && <OperacoesFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />}

        <OperacoesTable data={data} loading={loading} onRowClick={enableRowClick ? handleRowClick : undefined} onEditar={showActions ? handleEditar : undefined} onExcluir={showActions ? handleExcluir : undefined} totalRegistros={totalRegistros} paginationState={paginationState} setPaginationState={handlePaginationChange} />
      </CardBody>
    </Card>;
};

export default OperacoesCard;
